import { TranslationType } from '../types';

export const fraudDetectionIndicatorMapping = (t: TranslationType) => {
  const mapping = {
    yes: t('Yes'),
    no: t('No')
  };
  return mapping;
};
